import React, { useEffect, useState } from "react";
import { InputOTP } from "antd-input-otp";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Button, Form, Space, Flex } from "antd";
import {
  resendVerifyEmail,
  verifyForgotPassword,
} from "../../../../../redux/services/auth/authServices";
import { colors } from "../../../../../constants/colors";
import useUserToken from "../../../../../hooks/useToken";
import { appConfig } from "../../../../../constants/config/appConfig";
import styles from "./ForgotPasswordVerification.module.scss";
const { Title } = Typography;

const ForgotPasswordVerification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { userEmail } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [counter, setCounter] = useState(59);

  const [userToken, setUserToken] = useUserToken(appConfig.SESSION_USER_TOKEN);

  const formattedCounter =
    counter >= 0 ? `${counter < 10 ? "0" : ""}${counter}` : "00";

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const validateOTP = (rule, value, callback) => {
    if (!value || value.length !== 6) {
      callback(t("Otp.otpErrorMessage"));
    } else {
      callback();
    }
  };

  const onFinish = () => {
    form.validateFields().then((values) => {
      const { otp } = values;
      const convertedString = otp.join("");
      if (!otp || otp.includes(undefined) || otp.includes("")) {
        form.setFields([
          {
            name: t("Otp.otpText"),
            errors: [t("Otp.otpErrorMessage")],
          },
        ]);
      } else {
        let forgotPasswordBody = {
          email: userEmail.email,
          code: convertedString,
        };
        dispatch(
          verifyForgotPassword(
            forgotPasswordBody,
            navigate,
            setLoading,
            setUserToken
          )
        );
      }
    });
  };

  const handleResendOtp = () => {
    let resendBody = {
      email: userEmail?.email,
    };
    if (counter === 0) {
      form.resetFields(["otp"]);
      dispatch(resendVerifyEmail(resendBody, setIsLoading, resendVerifyEmail));
      setCounter(59);
    }
  };

  return (
    <>
      <Flex
        vertical
        gap="0.6rem"
        className={styles.forgotPasswordVerificationContainer}
      >
        <Title level={1} style={{ color: colors.primaryColor }}>
          {t("Otp.emailOtpTitle")}
        </Title>
        <Title level={4} type="secondary" style={{ margin: 0 }}>
          {t("Otp.subTitle")}
        </Title>
        <Title level={4} style={{ margin: 0 }}>
          {userEmail?.email ? `${userEmail?.email}` : ""}
        </Title>

        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
          form={form}
        >
          <Flex vertical gap="10rem">
            <div>
              <Form.Item name="otp" rules={[{ validator: validateOTP }]}>
                <InputOTP
                  autoFocus
                  inputType="numeric"
                  length={6}
                  inputClassName={styles.otpInputClassName}
                  wrapperClassName={styles.otpWrapperClassName}
                  disabled={userEmail?.email ? false : true}
                />
              </Form.Item>

              {userEmail?.email ? (
                <Space>
                  <Title level={5}>{`00 : ${formattedCounter}`}</Title>
                  <Title
                    level={5}
                    type="success"
                    disabled={counter === 0 ? false : true}
                    style={{
                      cursor: "pointer",
                      pointerEvents: counter !== 0 ? "none" : "visible",
                    }}
                    loading={isloading}
                    underline={true}
                    onClick={handleResendOtp}
                  >
                    {t("Otp.resendText")}
                  </Title>
                </Space>
              ) : (
                ""
              )}
            </div>
            <Button
              type="primary"
              className={styles.buttonStyle}
              htmlType="submit"
              loading={loading}
              disabled={userEmail?.email ? false : true}
            >
              {t("Otp.submit")}
            </Button>
          </Flex>
        </Form>
      </Flex>
    </>
  );
};

export default ForgotPasswordVerification;
